import React from 'react';

const InstagramIcon: React.FC<
  React.PropsWithChildren<React.SVGProps<SVGSVGElement>>
> = (props) => {
  return (
    <svg
      width="32.24px"
      height="32.24px"
      viewBox="0 0 32.24 32.24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      {...props}
    >
      <defs>
        <polygon
          id="path-1"
          points="0 0 31.537788 0 31.537788 31.53816 0 31.53816"
        ></polygon>
      </defs>
      <g
        id="Page-1"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g id="BBdomu.cz_prihlasen_V2" transform="translate(-72, -2921.76)">
          <g id="pata" transform="translate(0, 2530)">
            <rect
              id="Mask"
              fill="#E9B400"
              x="0"
              y="0"
              width="1440"
              height="574"
            ></rect>
            <g id="insta" transform="translate(72, 391.76)">
              <path
                d="M15.76908,12.88732 C14.17692,12.88732 12.88732,14.17816 12.88732,15.76908 C12.88732,17.36124 14.17692,18.65084 15.76908,18.65084 C17.36124,18.65084 18.65084,17.36124 18.65084,15.76908 C18.65084,14.17816 17.36124,12.88732 15.76908,12.88732"
                id="Fill-1"
                fill="#5A3218"
              ></path>
              <path
                d="M20.384608,12.191556 C19.811728,12.191556 19.346728,11.726556 19.346728,11.153676 C19.346728,10.580796 19.811728,10.115796 20.384608,10.115796 C20.957488,10.115796 21.422488,10.580796 21.422488,11.153676 C21.422488,11.726556 20.957488,12.191556 20.384608,12.191556 M15.769328,20.209396 C13.316608,20.209396 11.328888,18.221676 11.328888,15.768956 C11.328888,13.317476 13.316608,11.329756 15.769328,11.329756 C18.220808,11.329756 20.208528,13.317476 20.208528,15.768956 C20.208528,18.221676 18.220808,20.209396 15.769328,20.209396 M22.508728,10.670076 C22.352488,10.265836 22.165248,9.978156 21.862688,9.675596 C21.560128,9.373036 21.272448,9.185796 20.868208,9.029556 C20.563168,8.910516 20.105608,8.769156 19.262408,8.730716 C18.351008,8.689796 18.078208,8.681116 15.769328,8.681116 C13.460448,8.681116 13.186408,8.689796 12.275008,8.730716 C11.433048,8.769156 10.974248,8.910516 10.670448,9.029556 C10.266208,9.185796 9.978528,9.373036 9.675968,9.675596 C9.373408,9.978156 9.186168,10.265836 9.028688,10.670076 C8.910888,10.975116 8.769528,11.432676 8.731088,12.275876 C8.690168,13.187276 8.681488,13.460076 8.681488,15.768956 C8.681488,18.077836 8.690168,18.351876 8.731088,19.263276 C8.769528,20.106476 8.910888,20.564036 9.028688,20.869076 C9.186168,21.272076 9.373408,21.559756 9.675968,21.862316 C9.978528,22.164876 10.266208,22.352116 10.670448,22.509596 C10.974248,22.628636 11.433048,22.768756 12.275008,22.807196 C13.186408,22.848116 13.460448,22.858036 15.769328,22.858036 C18.078208,22.858036 18.351008,22.848116 19.262408,22.807196 C20.105608,22.768756 20.563168,22.628636 20.868208,22.509596 C21.272448,22.352116 21.560128,22.164876 21.862688,21.862316 C22.165248,21.559756 22.352488,21.272076 22.508728,20.869076 C22.627768,20.564036 22.767888,20.106476 22.807568,19.263276 C22.848488,18.351876 22.857168,18.077836 22.857168,15.768956 C22.857168,13.460076 22.848488,13.187276 22.807568,12.275876 C22.767888,11.432676 22.627768,10.975116 22.508728,10.670076"
                id="Fill-3"
                fill="#5A3218"
              ></path>
              <g id="Group-7">
                <mask id="mask-2" fill="white">
                  <use xmlnsXlink="#path-1"></use>
                </mask>
                <g id="Clip-6"></g>
                <path
                  d="M24.363148,19.33408 C24.320988,20.25416 24.174668,20.88284 23.961388,21.4334 C23.740668,22.00132 23.444308,22.48368 22.964428,22.9648 C22.483308,23.44468 22.000948,23.74104 21.433028,23.96176 C20.882468,24.17504 20.253788,24.32136 19.333708,24.36352 C18.411148,24.40568 18.117268,24.4156 15.768708,24.4156 C13.421388,24.4156 13.126268,24.40568 12.203708,24.36352 C11.283628,24.32136 10.654948,24.17504 10.105628,23.96176 C9.536468,23.74104 9.055348,23.44468 8.574228,22.9648 C8.093108,22.48368 7.797988,22.00132 7.577268,21.4334 C7.362748,20.88284 7.216428,20.25416 7.175508,19.33408 C7.132108,18.41152 7.123428,18.11764 7.123428,15.76908 C7.123428,13.42052 7.132108,13.12664 7.175508,12.20408 C7.216428,11.284 7.362748,10.65532 7.577268,10.106 C7.797988,9.53684 8.093108,9.05448 8.574228,8.5746 C9.055348,8.09348 9.536468,7.79836 10.105628,7.57764 C10.654948,7.36312 11.283628,7.2168 12.203708,7.17464 C13.126268,7.13372 13.421388,7.12256 15.768708,7.12256 C18.117268,7.12256 18.411148,7.13372 19.333708,7.17464 C20.253788,7.2168 20.882468,7.36312 21.433028,7.57764 C22.000948,7.79836 22.483308,8.09348 22.964428,8.5746 C23.444308,9.05448 23.740668,9.53684 23.961388,10.106 C24.174668,10.65532 24.320988,11.284 24.363148,12.20408 C24.405308,13.12664 24.415228,13.42052 24.415228,15.76908 C24.415228,18.11764 24.405308,18.41152 24.363148,19.33408 M15.768708,0 C7.060188,0 -0.000372,7.06056 -0.000372,15.76908 C-0.000372,24.47884 7.060188,31.53816 15.768708,31.53816 C24.478468,31.53816 31.537788,24.47884 31.537788,15.76908 C31.537788,7.06056 24.478468,0 15.768708,0"
                  id="Fill-5"
                  fill="#5A3218"
                ></path>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export default InstagramIcon;
